import React from "react";
import "./style.scss";
import { useTranslation } from "react-i18next";
import CheckIcon from "../../../../assets/icon-check.svg";

type PropType = {
  selectedSubAccount: string | null;
  subAccounts: Array<{
    id: number;
    sub_number: string;
    name: string;
  }>;
  onClose: () => void;
  onSelect: (subAccount: string | null) => void;
};

export const SubAccountModal: React.FC<PropType> = ({
  onClose,
  onSelect,
  selectedSubAccount,
  subAccounts,
}) => {
  const { t } = useTranslation("app");

  const items = [
    { name: t("mainAccount"), sub_number: null },
    ...subAccounts.map((subAccount) => ({
      name: "#" + subAccount.sub_number + " - " + subAccount.name,
      sub_number: String(subAccount.id),
    })),
  ];

  return (
    <div className="bottom-sheet-modal-wrapper">
      <div onClick={onClose} className="outlet-edit-profil-img"></div>

      <div className="edit-profil-img">
        <div className="edit-profil-img-header">
          <p>{t("selectAccount")}</p>
        </div>

        {items.map((item, i) => (
          <div
            key={i}
            onClick={() => {
              onSelect(item.sub_number);
            }}
            className="sub-account-row"
          >
            <div>
              <p>{item.name}</p>
            </div>

            {selectedSubAccount === item.sub_number && (
              <img src={CheckIcon} alt="CheckIcon" />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
